<tec-pwcs-layout
    [ngClass]="{ dark: designService.isDarkMode()}"
    [subtitle]="subtitle">
    <tec-progress [value]="progressService.getValue()"></tec-progress>

    <ng-container content>
        <div [ngClass]="['grid', getGridSize()]">
            @for (opt of operation.config.operations; track opt; let index = $index) {
                @if (opt.type === OPERATION_TYPE.POL) {
                <tec-card-access
                    [tagImage]="docTagImage(opt.type, index)"
                    [title]="'CHOOSE.POL_TITLE' | translate"
                    [description]="'CHOOSE.POL_DESCRIPTION' | translate"
                    (click)="goToOperation(opt.type, index)"
                ></tec-card-access>
                }
                @if (opt.type === OPERATION_TYPE.OCR) {
                <tec-card-access
                    [tagImage]="docTagImage(opt.type, index)"
                    [title]="'CHOOSE.OCR_TITLE' | translate"
                    [description]="'CHOOSE.OCR_DESCRIPTION' | translate"
                    (click)="goToOperation(opt.type, index)"
                ></tec-card-access>
                }
                @if (opt.type === OPERATION_TYPE.DOCUMENTS) {
                @if (docOperation(index)?.config?.docs?.length) {
                    @if (docOperation(index)?.config?.docs?.[0]) {
                        @let doc = docOperation(index)?.config?.docs[0];
                        <tec-card-access
                            [tagImage]="docTagImage(doc.type, index)"
                            [title]="resolveText(doc.title) || docText(doc.type).title"
                            [description]="resolveText(doc.description) || docText(doc.type).description"
                            (click)="goToOperation(opt.type, index)"
                        ></tec-card-access>
                    }
                }
                }
                @if (opt.type === OPERATION_TYPE.CONNECTIONS) {
                    <tec-card-access
                        [tagImage]="docTagImage(opt.config['type'], index)"
                        [title]="docText(opt.config['type']).title"
                        [description]="docText(opt.config['type']).description"
                        (click)="goToOperation(opt.type, index)"
                    ></tec-card-access>
                }
            }
        </div>
    </ng-container>

    <tec-nav-help [elements]="navsHelp" (clickEvent)="navHelpChange($event)"></tec-nav-help>
</tec-pwcs-layout>

<app-modal-scan-qr
    [ngClass]="{ dark: designService.isDarkMode() }"
    [(isVisible)]="isVisibleScan"
    [url]="auth.getQRUrl()"
/>
